import SectionMessage from "@atlaskit/section-message";
import React from "react";
var ErrorSection = function (_a) {
    var id = _a.id, message = _a.message;
    return (React.createElement(SectionMessage, { appearance: "error", title: "Error" }, message ? (React.createElement("p", null, message)) : (React.createElement("p", null,
        "Could not retrieve logging metadata for service: ",
        id))));
};
export default ErrorSection;
